import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import styles from './arc-radio-group.styles.js';
export default class ArcRadioGroup extends LitElement {
    constructor() {
        super(...arguments);
        this.row = false;
    }
    handleFocusIn() {
        const slottedChildren = this.defaultSlot.assignedElements({ flatten: true });
        const checkedRadio = [...slottedChildren].find(el => el.tagName === 'ARC-RADIO' && el.checked);
        checkedRadio === null || checkedRadio === void 0 ? void 0 : checkedRadio.focus();
    }
    render() {
        return html `
      <div id="main">
        <label id="label">
          <slot name="label">${this.label}</slot>
        </label>
        <div id="radioGroup" role="radiogroup" @focusin=${this.handleFocusIn}>
          <slot></slot>
        </div>
      </div>
    `;
    }
}
ArcRadioGroup.tag = 'arc-radio-group';
ArcRadioGroup.styles = styles;
__decorate([
    query('slot:not([name])')
], ArcRadioGroup.prototype, "defaultSlot", void 0);
__decorate([
    property({ type: String })
], ArcRadioGroup.prototype, "label", void 0);
__decorate([
    property({ type: Boolean })
], ArcRadioGroup.prototype, "row", void 0);
